import { cn } from '@costar-ui/cosmos';
import React__default from 'react';
import { ArticlePromo } from './article-promo.esm.js';

var ImageOrientation = /*#__PURE__*/function (ImageOrientation) {
  ImageOrientation[ImageOrientation["Side"] = 0] = "Side";
  ImageOrientation[ImageOrientation["Top"] = 1] = "Top";
  return ImageOrientation;
}({});
/**
 * @description
 * **A molecule component that accepts an image element and returns the composition of a ArticlePromo with the oriented image**
 *
 * Requires following element props
 * >- imageElement
 * >- articleTitleElement
 * >- categoryBarElement
 * >- articlePreviewElement

 * @property {string} **[className]**: optional prop to add additional tailwind classNames
 * @property {ImageOrientation} **[imageOrientation]**: optional prop that determines orientation of image in relation to ArticlePromo
 * >- Side _[default]_
 * >- Top
 *
 * @example
 * <ArticlePromoWithImage
 *    articleTitleElement={featuredArticleTitle}
 *    categoryBarElement={categoryBarElement}
 *    imageElement={featuredArticleImage}
 *    className="mx-4 lg:mx-0"
 *    imageOrientation={ImageOrientation.Top}
 * />
 */
var ArticlePromoWithImage = function ArticlePromoWithImage(props) {
  var imageElement = props.imageElement,
    articleTitleElement = props.articleTitleElement,
    categoryBarElement = props.categoryBarElement,
    articlePreviewElement = props.articlePreviewElement,
    articlePromoContainerStyle = props.articlePromoContainerStyle,
    _props$imageOrientati = props.imageOrientation,
    imageOrientation = _props$imageOrientati === void 0 ? ImageOrientation.Side : _props$imageOrientati,
    className = props.className;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn('flex flex-row gap-4', {
      'flex-col': imageOrientation == ImageOrientation.Top
    }, className)
  }, /*#__PURE__*/React__default.createElement("figure", null, imageElement), /*#__PURE__*/React__default.createElement(ArticlePromo, {
    articleTitleElement: articleTitleElement,
    categoryBarElement: categoryBarElement,
    articlePreviewElement: articlePreviewElement,
    articlePromoContainerStyle: articlePromoContainerStyle
  }));
};

export { ArticlePromoWithImage, ImageOrientation };
//# sourceMappingURL=article-promo-with-image.esm.js.map
